import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as Arrow } from '../../../../assets/tariffs/arrow-down.svg'
import classNames from 'classnames'
import { Fragment, useEffect, useRef, useState } from 'react'
import { CountriesStore } from '../../career/CoopPop'
import { Cities } from '../../terminals/TerminalsCol'
import GlobalState from '../../../../stores/GlobalState'
import { sortByCountry } from '../../../../mocks/sortByCountry'
const TariffsSelect = observer(
  ({
    isFlag = false,
    defaultValue,
    getValue,
    value,
    dt,
    isError,
    showInput = false,
    isTerminals = false,
  }: {
    isFlag: boolean
    defaultValue: string
    getValue: (value?: any) => void
    value: any
    dt: any
    isError: boolean
    showInput?: boolean
    isTerminals?: boolean
  }) => {
    const [list, setList] = useState(dt)
    const [inputValue, setValue] = useState('')

    const [isOpen, setOpen] = useState(false)

    const ref = useRef<any>(null)

    useEffect(() => {
      if (!ref.current) return
      const inside = (e: any) => {
        if (!ref.current) return
        if (!ref.current.contains(e.target)) {
          setOpen(false)
          setValue('')
        }
      }

      document.addEventListener('click', inside)

      return () => document.removeEventListener('click', inside)
    }, [])

    useEffect(() => {
      if (!isFlag && showInput && isTerminals) {
        if (!inputValue.length) {
          setList(dt)
          return
        }

        const res = dt.filter((el: any) => {
          if (
            el.trim().toLowerCase().includes(inputValue.trim().toLowerCase())
          ) {
            return el
          }
        })

        setList(res)
      }
    }, [dt, inputValue, isFlag])

    useEffect(() => {
      if (isFlag && !isTerminals) {
        if (!inputValue.length) {
          setList(dt)
          return
        }
        if (CountriesStore.list) {
          const res = sortByCountry(
            CountriesStore.list,
            GlobalState.currentLocale.lang,
            inputValue,
          )
          setList(res)
        }
      }
      if (!isFlag && showInput && Cities.cities && !isTerminals) {
        if (!inputValue.length) {
          setList(dt.filter((d:any)=>d.includes('місто')))
          return
        }

        let res = (Cities.cities as any)
          ?.filter(
            (d: any) =>
              d.name.toLowerCase().slice(0, inputValue.length) ==
              inputValue.toLowerCase().trim(),
          )
          .map((r: any) => r.text)

        setList(res)
      }
    }, [
      inputValue,
      isFlag,
      dt,
      CountriesStore.list,
      Cities.cities,
      isTerminals,
    ])


    return (
      <section className="tariffs-select" ref={ref}>
        {isFlag ? (
          <div
            className={classNames(
              'tariffs-select__top',
              !value.flag.length && 'empty',
              isOpen && 'open',
              isError && 'error-select',
            )}
            onClick={() => setOpen(true)}
          >
            <>
              {showInput && !isOpen && (
                <>
                  {value.flag.length ? (
                    <>
                      <div className="tariffs-select__flag">
                        <img src={value.flag} />
                      </div>
                      <div className="tariffs-select__value">
                        {' '}
                        {value.country}
                      </div>
                    </>
                  ) : (
                    <div className="tariffs-select__value">{defaultValue}</div>
                  )}
                  <Arrow />
                </>
              )}
              {showInput && isOpen && (
                <>
                  <input
                    onClick={(e) => e.stopPropagation()}
                    className="tariffs-select__input"
                    onChange={(e) => setValue(e.target.value)}
                    autoFocus
                  />
                </>
              )}
            </>
          </div>
        ) : (
          <div
            className={classNames(
              'tariffs-select__top',
              !value.length && 'empty',
              isOpen && 'open',
            )}
            onClick={() => setOpen(!isOpen)}
          >
            {((!isOpen && showInput) || !showInput) && (
              <>
                <div className="tariffs-select__value">
                  {' '}
                  {value.length ? <>{value}</> : <>{defaultValue}</>}
                </div>
                <Arrow />
              </>
            )}

            {showInput && isOpen && (
              <>
                <input
                  onClick={(e) => e.stopPropagation()}
                  className="tariffs-select__input"
                  onChange={(e) => setValue(e.target.value)}
                  autoFocus
                />
              </>
            )}
          </div>
        )}
        <div
          className={classNames('tariffs-select__list', isOpen && 'open-list')}
        >
          <div className="tariffs-select__scroll">
            {list.map((d: any, i: number) => {
              if (!isFlag && value == d && !showInput)
                return <Fragment key={i}></Fragment>

              return (
                <div
                  className="tariffs-select__item"
                  key={i}
                  onClick={() => {
                    getValue(d)
                    setOpen(false)
                    setValue('')
                  }}
                >
                  {isFlag && (
                    <div className="tariffs-select__flag">
                      <img src={d.flag} />
                    </div>
                  )}
                  {isFlag ? d.country : d}
                </div>
              )
            })}
          </div>
        </div>
      </section>
    )
  },
)

export default TariffsSelect
